import Grid from "@mui/material/Grid";
import { Container } from "@mui/system";
import { Link, Navigate, useParams } from "react-router-dom";
import { GoPloof } from "../components/organisms/GoPloof";
import activites from "../components/utils/Activities";
import MetaMaster from "../components/utils/MetaMaster";
import { Button } from "../stories/atoms/Button";
import { HeroInner } from "../stories/organisms/HeroInner";

export default function ActivitesCategorie() {
    const { categorie } = useParams();

    // 🧠 Déterminer le profil à partir du slug
    let profil;
    switch (categorie) {
        case "bebes":
        case "bebe":
            profil = "bébé";
            break;
        case "enfants":
            profil = "enfant";
            break;
        case "adultes":
            profil = "adulte";
            break;
        case "seniors":
            profil = "sénior";
            break;
        default:
            profil = undefined;
    }

    // ⚠️ Si la catégorie est inconnue
    if (!profil) return <Navigate to="/activites" replace />;

    // 🧩 Récupérer la catégorie correspondante (isCategory)
    const category = activites.find((a) => a.profil === profil && a.isCategory);

    // 🧩 Récupérer toutes les activités de ce profil (non-catégories)
    const activities = activites.filter((a) => a.profil === profil && !a.isCategory);

    // 🧩 Images pour le Hero (si tu veux les recycler depuis tes données)
    const heroImages = [category?.src];

    const textes = {
        enfant: "Chez nous, l'accompagnement de vos enfants est bien plus qu'une priorité : c'est un engagement marqué par la bienveillance et le professionnalisme. Que ce soit pour les tout-petits, les bambins ou les adolescents, notre approche personnalisée favorise la progression de chaque enfant, avec des programmes adaptés à chaque étape de leur croissance. Notre équipe dédiée, spécialisée dans la natation et les bébés nageurs, s'engage à créer un environnement sécurisé et stimulant. C'est dans ce cadre que vos enfants peuvent s'épanouir tout en développant leurs compétences aquatiques. Faites-nous confiance pour offrir à vos petits une expérience enrichissante et encourageante qui les accompagnera tout au long de leur parcours aquatique.",
        adulte: "Quelle que soit votre condition physique ou vos objectifs, à Vital'Eau, nous avons une activité adaptée à chacun. Que vous soyez un athlète de haut niveau, une personne âgée, une femme enceinte, ou simplement à la recherche d'un moyen de maintenir votre forme physique, notre offre diversifiée saura répondre à vos besoins. Découvrez nos activités conçues pour promouvoir la santé et le bien-être, avec des programmes adaptés à tous les niveaux et encadrés par des professionnels qualifiés.",
        sénior: "Que vous souffriez de douleurs articulaires, de problèmes cardiovasculaires, ou que vous luttiez contre le surpoids, nos activités aquatiques sont spécialement conçues pour vous aider à améliorer votre état de santé global et vous conduire vers un bien-être généralisé. Rejoignez-nous et bénéficiez des multiples avantages de l'eau tout en profitant de l'ambiance conviviale qui règne au sein de nos séances. Laissez-vous porter par une expérience où la santé et la camaraderie se rejoignent pour favoriser votre mieux-être.",
        default:
            "Pour les petits, pour les grands, pour tous les profils et toutes les envies ! Chez Vital’Eau, nous proposons un large choix d’activités aquatiques. Que vous cherchiez à entretenir votre forme, à vous dépenser sans prise de tête ou à dépasser vos limites, il y a forcément une activité faite pour vous !",
    };

    return (
        <>
            <MetaMaster title={`Vital'Eau - ${category?.titre || "Activités"}`} />

            {/* 🏞️ Section Hero */}
            <HeroInner
                arianeItem={[
                    ["/", "Vital'Eau"],
                    ["/activites", "Nos activités"],
                    [`/activites/${categorie}`, category?.titre || "Activités"],
                ]}
                imagesSwiper={heroImages}
            />

            {/* 🟢 En-tête catégorie */}
            <section className="section-show-pool-home" id="accueil-histoire">
                <Container maxWidth="xl">
                    <Grid container justifyContent="center">
                        <Grid item lg={10} md={10} sm={12} xs={12}>
                            <div>
                                <h1 className="accueil-histoire-titre h1-inner" data-title={`Nos activités ${categorie}`}>
                                    Nos activités {categorie}
                                </h1>
                                <br />
                                <br />
                                <p className="text-center">{textes[profil] || textes.default}</p>{" "}
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </section>

            <section className="section-activite-categorie-list">
                <Container maxWidth="xl">
                    <Grid container spacing={4} justifyContent="center">
                        {activities.map((act) => (
                            <Grid item xs={12} sm={6} md={categorie === "enfants" ? 4 : 3} lg={categorie === "enfants" ? 4 : 3} key={act.titre}>
                                <Link
                                    to={`/activites/${categorie}/${act.slug}`}
                                    className="carte-liste-activite"
                                    style={{
                                        backgroundImage: `url(${act.src})`,
                                        backgroundSize: "cover",
                                        backgroundRepeat: "no-repeat",
                                        backgroundPosition: "center",
                                    }}
                                >
                                    <div style={{ position: "relative", zIndex: 2, textAlign: "center" }}>
                                        <h3 style={{ marginBottom: "8px" }}>{act.titre}</h3>
                                        <span>Découvrir</span>
                                    </div>
                                </Link>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </section>

            <GoPloof profil={profil} />

            <section className="section-contact">
                <Container maxWidth="xl">
                    <Grid container justifyContent={"center"}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <div>
                                <h2 className="accueil-histoire-titre" data-title="Ça te plaît ? ">
                                    Ça te plaît ?, <br />
                                    par ici les horaires
                                </h2>
                                <br />
                                <br />
                                <Button label="Planning" style={{ width: "fit-content", margin: "0 auto" }} primary href={"/planning"} />
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </section>
        </>
    );
}
